// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1jYrs","productName":"Table_productName__2CQvZ"};